import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import MusicApp from './components/music/app';
import App from './components/app';
import URL from 'url-parse';

class Root extends React.Component {
	render() {
		return (
			<Router>
				<Switch>
					<Route path="/s/music/:id/:reference" component={MusicApp} />
					<Route path="/s/:id/:reference/:question_id" component={App} />
					<Route path="/s/:id/:reference" component={App} />
					<Route path="/" component={MusicAppWithQuery} />
				</Switch>
			</Router>
		);
	}
}

const MusicAppWithQuery = () => {
	const url = new URL(window.location.href, true);

	return <MusicApp id={url.query.id} reference={url.query.ref}/>
}

export default Root;


// WEBPACK FOOTER //
// ./src/root.jsx